var App = App || {};

App.ZagBreakpoints = (function () {
    'use strict';

    // Define all breakpoints as MediaQueryList objects
    const breakpoints = {
        xs: window.matchMedia('(max-width: 575.98px)'),
        sm: window.matchMedia('(min-width: 576px) and (max-width: 767.98px)'),
        md: window.matchMedia('(min-width: 768px) and (max-width: 991.98px)'),
        lg: window.matchMedia('(min-width: 992px) and (max-width: 1199.98px)'),
        xl: window.matchMedia('(min-width: 1200px) and (max-width: 1399.98px)'),
        xxl: window.matchMedia('(min-width: 1400px)')
    };

    /* =========================================================================
    Helpers
    ========================================================================= */

    // Returns the current active breakpoint key (e.g., 'md').
    // Example usage: const currentBreakpointKey = App.ZagBreakpoints.getBreakpoint();
    function getBreakpoint() {
        for (const key of Object.keys(breakpoints)) {
            if (breakpoints[key].matches) {
                return key;
            }
        }
        return null;
    }

    // Returns the current viewport size as { width, height }.
    // Example usage: const viewportSize = App.ZagBreakpoints.getViewPortSize();
    function getViewPortSize() {
        let targetElement = window;
        let dimensionType = 'inner';

        if (!('innerWidth' in window)) {
            dimensionType = 'client';
            targetElement = document.documentElement || document.body;
        }

        return {
            width: targetElement[dimensionType + 'Width'],
            height: targetElement[dimensionType + 'Height']
        };
    }

    /* =========================================================================
    Public API Exposure
    ========================================================================= */

    return {
        breakpoints,
        getBreakpoint,
        getViewPortSize
    };

})();

(function () {
    'use strict';

    /* =========================================================================
        Helpers
    ========================================================================= */

    // Maps a MediaQueryList object to its breakpoint key.
    function getBreakpointKeyByMediaQuery(mediaQueryList) {
        const breakpoints = App.ZagBreakpoints.breakpoints;
        for (const key of Object.keys(breakpoints)) {
            if (breakpoints[key].media === mediaQueryList.media) {
                return key;
            }
        }
        return null;
    }

    /* =========================================================================
        Event Binding
    ========================================================================= */

    // Handles breakpoint changes and dispatches custom events like 'enter-lg'.
    function handleBreakpointChange(mediaQueryList) {
        const type = mediaQueryList.matches ? 'enter' : 'leave';
        const breakpointKey = getBreakpointKeyByMediaQuery(mediaQueryList);
        if (breakpointKey) {
            const event = new CustomEvent(`${type}-${breakpointKey}`);
            document.dispatchEvent(event);
        }
    }

    // Initializes event listeners for all breakpoints and dispatches initial events.
    // Example usages:
    // document.addEventListener("enter-lg", () => { console.log("enter lg"); });
    // document.addEventListener("leave-lg", () => { console.log("leave lg"); });

    function initBreakpointEvents() {
        const breakpoints = App.ZagBreakpoints.breakpoints;
        if (window.matchMedia) {
            for (const key of Object.keys(breakpoints)) {
                breakpoints[key].addEventListener('change', handleBreakpointChange);
                if (breakpoints[key].matches) {
                    const event = new CustomEvent(`enter-${key}`);
                    document.dispatchEvent(event);
                }
            }
        }
    }

    /* =========================================================================
        Public API Exposure
    ========================================================================= */

    // Expose the public API, preserving the previous properties
    App.ZagBreakpoints = {
        ...App.ZagBreakpoints,
        initBreakpointEvents
    };

    /* =========================================================================
        Initialization
    ========================================================================= */

    initBreakpointEvents();

})();